import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const CustomModal = ({ isOpen, onClose, body }) => {
    

    if (!isOpen) return null;

    return (
        <Modal isOpen={isOpen} toggle={onClose} centered>
            <ModalBody>
                {body}
            </ModalBody>
        </Modal>

    );
};

export default CustomModal;
